import { render, staticRenderFns } from "./UsersExerciseView.vue?vue&type=template&id=6fb851a4&"
import script from "./UsersExerciseView.vue?vue&type=script&lang=js&"
export * from "./UsersExerciseView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports